/**
 * Builds a JPEG File — solid color with light grain — for fabric upload flows.
 */
export function createFabricSwatchImageFile(hex, options = {}) {
  const { width = 900, height = 900 } = options;
  const normalizedHex = typeof hex === 'string' && hex.trim() ? hex.trim() : '#808080';

  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      reject(new Error('Canvas is not supported'));
      return;
    }

    ctx.fillStyle = normalizedHex;
    ctx.fillRect(0, 0, width, height);

    const imageData = ctx.getImageData(0, 0, width, height);
    const d = imageData.data;
    for (let i = 0; i < d.length; i += 4) {
      const n = (Math.random() - 0.5) * 16;
      d[i] = Math.min(255, Math.max(0, d[i] + n));
      d[i + 1] = Math.min(255, Math.max(0, d[i + 1] + n));
      d[i + 2] = Math.min(255, Math.max(0, d[i + 2] + n));
    }
    ctx.putImageData(imageData, 0, 0);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Could not create fabric swatch image'));
          return;
        }
        const file = new File([blob], `fabric-swatch-${Date.now()}.jpg`, { type: 'image/jpeg' });
        resolve(file);
      },
      'image/jpeg',
      0.92
    );
  });
}
